import { render, staticRenderFns } from "./StateDisplay.vue?vue&type=template&id=5c5dd939&scoped=true&"
import script from "./StateDisplay.vue?vue&type=script&lang=js&"
export * from "./StateDisplay.vue?vue&type=script&lang=js&"
import style0 from "./StateDisplay.vue?vue&type=style&index=0&id=5c5dd939&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5dd939",
  null
  
)

export default component.exports